module.exports = __webpack_public_path__ + "assets/img/ability33.0637332a.png";